import { viteEnv } from "utils/vite-env.util";

// Type for the feature flag object containing API URLs
interface BeApiUrlsConfig {
  api_url?: string;
  ws_url?: string;
}

// Global configuration store for dynamic API routing
class ApiConfiguration {
  private currentApiUrl: string;
  private currentWsUrl: string;

  constructor() {
    // Initialize with fallback environment values
    this.currentApiUrl = viteEnv.VITE_SUNO_API;
    this.currentWsUrl = viteEnv.VITE_SUNO_WS;
  }

  // Update configuration based on feature flag object
  updateFromFeatureFlag(beApiUrls?: BeApiUrlsConfig) {
    if (beApiUrls?.api_url) {
      this.currentApiUrl = beApiUrls.api_url;
    } else {
      // Fallback to environment variable
      this.currentApiUrl = viteEnv.VITE_SUNO_API;
    }

    if (beApiUrls?.ws_url) {
      this.currentWsUrl = beApiUrls.ws_url;
    } else {
      // Fallback to environment variable
      this.currentWsUrl = viteEnv.VITE_SUNO_WS;
    }
  }

  getApiUrl(): string {
    return this.currentApiUrl;
  }

  getWsUrl(): string {
    return this.currentWsUrl;
  }
}

// Global singleton instance
export const apiConfig = new ApiConfiguration();

// Helper functions for easy access
export const getDynamicApiUrl = (): string => {
  return apiConfig.getApiUrl();
};

export const getDynamicWsUrl = (): string => {
  return apiConfig.getWsUrl();
};

// Function to update configuration when feature flag changes
export const updateApiConfigFromFeatureFlag = (beApiUrls?: BeApiUrlsConfig) => {
  apiConfig.updateFromFeatureFlag(beApiUrls);
};
